import { useState } from "react";
import { BrokenImage } from "@mui/icons-material";
import { Box, CircularProgress, Typography } from "@mui/material";

const InsuranceOption = ({ option, props }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  
  const IMG =
    option.imagen === null
      ? "https://www.movicaremx.com/IMG/app_mobile/FormatPNG/Perfil/Ajolomovi_H.png"
      : option.imagen;

  return (
    <li {...props}>
      <Box sx={design.BoxInst}>
        <Box sx={design.BoxIMG}>
          {loading && !error && <CircularProgress size={22} thickness={4} />}
          {!error && (
            <Box
              component="img"
              src={IMG}
              loading="lazy"
              onLoad={() => setLoading(false)}
              onError={() => {
                setLoading(false);
                setError(true);
              }}
              style={{
                display: loading ? "none" : "block",
                ...design.Img,
              }}
            />
          )}
          {error && <BrokenImage sx={design.Broken} />}
        </Box>

        <Box flex={1}>
          <Typography fontWeight={700} fontSize={15}>
            {option.name}
          </Typography>
        </Box>
        <Typography fontSize={13} color="#c2c2c2">
          Ranking
        </Typography>
        <Box sx={design.Chip}>#{option.ranking}</Box>
      </Box>
    </li>
  );
};

export default InsuranceOption;

const design = {
  BoxInst: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: 2,
    p: 1.5,
    borderRadius: 2,
    transition: "all .2s",
    "&:hover": {
      bgcolor: "#F5F8FF",
    },
  },
  BoxIMG: {
    width: 60,
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 2,
    bgcolor: "#fff",
    border: "1px solid #E5E7EB",
    p: 1,
    position: "relative",
    overflow: "hidden",
    flexShrink: 0,
  },
  Img: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  Broken: {
    color: "#BDBDBD",
    fontSize: 30,
  },
  Chip: {
    px: 1.5,
    py: 0.5,
    borderRadius: 10,
    bgcolor: "#EEF4FF",
    color: "#2349D0",
    fontWeight: 700,
    fontSize: 13,
  },
};
